import moment, {now} from "jalali-moment";
import {DateObject} from "react-multi-date-picker";
import {ACCESS_TOKEN} from "./redux/action/type.action";
import {substr} from "./functions/strings/substr";
import {strlen} from "./functions/strings/strlen";

export const numOnKeyDown = (event) => {
    console.log(event.which,"add something")
    // if ((event.which !== 8 && event.which !== 0) && ((event.which < 48 || event.which > 57) && ( event.which < 96 || event.which > 105)))
    // {
    //     event.preventDefault();
    // }
    if (["e", "E", "+", "-"].includes(event.key) && event.preventDefault()) {
        return false
    }
}

export const sleep = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);

export const saveAccessToken = async (value) => await localStorage.setItem(ACCESS_TOKEN, value);
export const getAccessToken = async () => localStorage.getItem(ACCESS_TOKEN);
export const saveLang = async (value) => await localStorage.setItem("lang", value);
export const getLang = (def = 'fa') => localStorage.getItem("lang") ?? def;


export const scrollToTop = () => {
    setTimeout(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    }, 200);
}

export const isValidMobile = (value) => {
    if (value.trim().length !== 11) return false;
    return value.substring(0, 2) === '09';

}

export const isValidFullname = (value) => {
    if (value.trim().length < 3) return false;
    return true
}

export const isValidAddress = (value) => {
    if (value.trim().length < 3) return false;
    return true;
}

export const isValidOtp = (value) => {
    return value.trim().length === 5;
}

export const isValidHour = (value) => {
    if (value < 0 && value > 24 && value.trim()) return false;
}

export const isValidNationalCode = (code) => {
        // code = parseInt(code);
        let codeLen = strlen(code);
        if (codeLen < 8 || parseInt(code) === 0) {
            return false;
        }

        code = substr('0000' + code, codeLen + 4 - 10);
        if (parseInt(substr(code, 3, 6)) === 0) {
            return false;
        }

        let c = parseInt(code[9]);
        let s = 0;
        for (let i = 0; i < 9; i++) {
            s += parseInt(code[i]) * (10 - i);
        }
        s %= 11;
        return (s < 2 && c === s) || (s >= 2 && c === (11 - s));
}



export const upTo = (el, tagName, className = null) => {
    tagName = tagName.toLowerCase();

    while (el && el.parentNode) {
        el = el.parentNode;
        if (el.tagName && el.tagName.toLowerCase() === tagName && (el?.className?.indexOf(className) >= 0 || className === null)) {
            return el;
        }
    }

    // Many DOM methods return null if they don't
    // find the element they are searching for
    // It would be OK to omit the following and just
    // return undefined
    return null;
}
export const destroyElement = async (item, deleteCallback = null) => {
    if (!Boolean(item)) return false;
    console.log(item)
    item.style.opacity = 1;
    let tmr = setInterval(() => {
        item.style.opacity = item.style.opacity - 0.05;
    }, 5);

    while (item.style.opacity > 0.2) {
        await sleep(20);
    }

    if (item.style.opacity <= 0.2) {
        clearInterval(tmr);
        // item.style.display = 'none'
    }

    console.log('elm', 'end of destroy element')

    if (deleteCallback) await deleteCallback();
    await sleep(200)
    item.style.opacity = 1;
    console.log('after delete callback')
}

export const whiteSpace = (count) => {

    let out = "";
    for (let i = 0; i < count; i++) {
        out = out + "\u00A0"
    }
    return out;
}

export const isEven = (num) => {
    // num%2===0 ? true : false
    if (num % 2 === 0) {
        return true
    } else {
        return false
    }
};
export const logTable = (data) => {
    console.table(data)
};
export const log = (data) => {
    console.log(data)
};
export const logCount = (data) => {
    console.count(data)
}

export const limitString = (value, len = 12) => {
    if (value.length <= len) return value;
    return value.substring(0, len) + '...';
}


// export const isEmpty = (str) => {
//     return (!str || str.length === 0);
// }


export const isEmpty = (mixedVar) => {
    let undef
    let key
    let i
    let len
    const emptyValues = [undef, null, false, 0, '', '0']

    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixedVar === emptyValues[i]) {
            return true
        }
    }

    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false
            }
        }
        return true
    }

    if (typeof mixedVar === 'string') {
        return mixedVar.trim().length === 0;
    }

    return false
}





export const validPassword = (value) => {
    let regularUpperCase = /(?=.*[A-Z])/;
    let regularLowerCase = /(?=.*[a-z])/;
    let regularNumber = /(?=.*[0-9])/;

    return (regularUpperCase.test(value) && regularLowerCase.test(value) && regularNumber.test(value) && value.length >= 8)
}

export const isValidEmail = (value) => {
    if (!value) {
        return false;
    } else if (!/\S+@\S+\.\S+/.test(value)) {
        return false;
    }
    return true;
}

export const isValidPhone = (value) => {
    if (value.trim().length !== 11) return false;
    return value.substring(0, 1) === '0';
}


export const getDurationTimeFrom = (jalaliDate, locale = 'fa', format = 'jYYYY-jMM-jDD HH:mm') => {
    let res = moment.from(jalaliDate, locale, format).diff(now(), 'second');
    // res = res.replaceAll('hours', 'ساعت')
    //     .replaceAll('hour', 'ساعت')
    //     .replaceAll('minutes', 'دقیقه')
    //     .replaceAll('minute', 'دقیقه')
    //     .replaceAll('seconds', 'ثانیه')
    //     .replaceAll('second', 'ثانیه')
    //     .replaceAll('months', 'ماه')
    //     .replaceAll('month', 'ماه')
    //     .replaceAll('days', 'روز')
    //     .replaceAll('day', 'روز')
    //     .replaceAll('years', 'سال')
    //     .replaceAll('year', 'سال')
    //     .replaceAll('in', '')
    //     .replaceAll('ago', '')
    //     .replaceAll('an', 'یک')
    //     .replaceAll('a', 'یک')

    return convertSecondsToTime(res);
}

export const convertSecondsToTime = (seconds) => {
    let suffix = seconds < 0 ? 'قبل' : 'بعد';
    seconds = seconds < 0 ? seconds * (-1) : seconds;
    let year = 0;
    let month = 0;
    let day = 0;
    let hour = 0;
    let minute = 0;

    while (seconds >= 31104000) {
        seconds -= 31104000;
        year++;
    }
    while (seconds >= 2592000) {
        seconds -= 2592000;
        month++;
    }

    while (seconds >= 86400) {
        seconds -= 86400;
        day++;
    }

    while (seconds >= 3600) {
        seconds -= 3600;
        hour++;
    }

    while (seconds >= 60) {
        seconds -= 60;
        minute++;
    }
    // if (hour <= 9) {
    //     hour = `0${hour}`;
    // }
    if (minute <= 9) {
        minute = `0${minute}`;
    }
    if (seconds <= 9) {
        seconds = `0${seconds}`;
    }

    // generate date
    let res = year > 0 ? `${year} سال و` : '';
    res += month > 0 ? `${month} ماه و` : '';
    if (year === 0)
        res += day > 0 ? `${day} روز و` : '';

    res = rtrim(res, 'و');

    // generate time
    let time = parseInt(hour) > 0 ? `${hour} ساعت و ` : '';
    time += parseInt(minute) > 0 ? `${minute} دقیقه ` : '';
    time = rtrim(time, ' و');

    return (res.trim() === '' ? time : res) + ' ' + suffix;
}

export const rtrim = (str, charlist) => {
    charlist = !charlist
        ? ' \\s\u00A0'
        : (charlist + '').replace(/([[\]().?/*{}+$^:])/g, '\\$1')
    const re = new RegExp('[' + charlist + ']+$', 'g')
    return (str + '').replace(re, '')
}


export const escapedNewLineToLineBreakTag = (string) => {
    return string.split('\n').map((item, index) => {
        return (index === 0) ? item : [<br key={index} />, item]
    })
}

export const betweenRange = (start,end,value) => {
    if(value.trim()==='') return  true;
    let intStart=parseInt(start);
    let intEnd=parseInt(end);
    let intValue=parseInt(value);

    if(intStart<=intValue && intValue <=intEnd) {
        return true
    }else {
        return false
    }
}

export const getRandomInt = (min, max)=>{
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const number_format = (number, decimals, decPoint, thousandsSep)=>{

    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    const n = !isFinite(+number) ? 0 : +number
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    let s = ''

    const toFixedFix = function (n, prec) {
        if (('' + n).indexOf('e') === -1) {
            return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
        } else {
            const arr = ('' + n).split('e')
            let sig = ''
            if (+arr[1] + prec > 0) {
                sig = '+'
            }
            return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
        }
    }

    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
}

export const str_shuffle = (str, length = 0) => {

    if (str === null) {
        return ''
    }

    str += ''

    let newStr = ''
    let rand
    let i = str.length

    while (i) {
        rand = Math.floor(Math.random() * i)
        newStr += str.charAt(rand)
        str = str.substring(0, rand) + str.substr(rand + 1)
        i--
    }

    if (length === 0) return newStr
    return newStr.substr(0, length - 1);
}

export const isRTL = (s) => {
    const rtlChars = '\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC';
    const rtlDirCheck = new RegExp('^[^' + rtlChars + ']*?[' + rtlChars + ']');

    return rtlDirCheck.test(s);
};


export const nonBreaking = (value, zero = true) => {
    return str_replace(' ', String.fromCharCode(zero ? 0 : 160), value)
}


export const faToEnNum = (value) => {
    value = str_replace(['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'], ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], value);
    return str_replace(['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'], ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], value);
}

export const enToFaNum = (value) => {
    // const lng = i18n.language;
    // if (lng !== 'fa') return value;
    value = str_replace(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'], value);
    return str_replace(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'], ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'], value);

}

export const getMonthName = (m) => {
    let months = [
        '-',
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ] ;

    return months[m >= 1 && m <= 12 ? m : 1]
}
export const toStringDate = (date, showYear = true) => {
    if (isEmpty(date)) return null;
    let arr = date.split(' ');
    let d = arr[0]?.split(date.includes('-') ? '-' : '/');

    let monthName = getMonthName(parseInt(d[1]));

    return `${d[2]} ${monthName} ` + (showYear ? d[0] : '') + (!isEmpty(arr[1]) ? '، ' + makeTimeTwoNum(arr[1]) : '');
}


export const str_replace = (search, replace, subject, countObj) => {
    let i = 0
    let j = 0
    let temp = ''
    let repl = ''
    let sl = 0
    let fl = 0
    const f = [].concat(search)
    let r = [].concat(replace)
    let s = subject
    let ra = Object.prototype.toString.call(r) === '[object Array]'
    const sa = Object.prototype.toString.call(s) === '[object Array]'
    s = [].concat(s)

    const $global = (typeof window !== 'undefined' ? window : global)
    $global.$locutus = $global.$locutus || {}
    const $locutus = $global.$locutus
    $locutus.php = $locutus.php || {}

    if (typeof (search) === 'object' && typeof (replace) === 'string') {
        temp = replace
        replace = []
        for (i = 0; i < search.length; i += 1) {
            replace[i] = temp
        }
        temp = ''
        r = [].concat(replace)
        ra = Object.prototype.toString.call(r) === '[object Array]'
    }

    if (typeof countObj !== 'undefined') {
        countObj.value = 0
    }

    for (i = 0, sl = s.length; i < sl; i++) {
        if (s[i] === '') {
            continue
        }
        for (j = 0, fl = f.length; j < fl; j++) {
            if (f[j] === '') {
                continue
            }
            temp = s[i] + ''
            repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0]
            s[i] = (temp).split(f[j]).join(repl)
            if (typeof countObj !== 'undefined') {
                countObj.value += ((temp.split(f[j])).length - 1)
            }
        }
    }
    return sa ? s : s[0]
}

export const makeTimeTwoNum = (timeStr, showSecond = false) => {
    if (isEmpty(timeStr)) return 'نامشخص'
    if (timeStr.trim().length < 1) return timeStr;
    let arr = timeStr?.trim()?.split(':');
    let res = '';
    arr.map((i, x) => {
        if (!showSecond && x >= 2) return;
        res = res + (i.length < 2 ? `0${i}:` : `${i}:`);
    })

    res = rtrim(res, ':');
    // console.log('rrrrrrrrrr',res)
    return res;
}
export const isActiveToBook = (selectedDate, time = '', format = 'YYYY-MM-DD') => {
    let today = new DateObject({
        date: new Date(),
        format: format
    });

    if (selectedDate > today.format(format))
        return true;

    if (selectedDate === today.format(format))
        return time?.trim() !== '' && time >= today.format('HH:mm');

    return false;
}

export const SecondsToTime = (seconds) => {

    let year = 0;
    let month = 0;
    let day = 0;
    let hour = 0;
    let minute = 0;

    while (seconds >= 31104000) {
        seconds -= 31104000;
        year++;
    }
    while (seconds >= 2592000) {
        seconds -= 2592000;
        month++;
    }

    while (seconds >= 86400) {
        seconds -= 86400;
        day++;
    }

    while (seconds >= 3600) {
        seconds -= 3600;
        hour++;
    }

    while (seconds >= 60) {
        seconds -= 60;
        minute++;
    }
    // if (hour <= 9) {
    //     hour = `0${hour}`;
    // }
    if (minute <= 9) {
        minute = `0${minute}`;
    }
    if (seconds <= 9) {
        seconds = `0${seconds}`;
    }

    return `${hour > 0 ? hour + ':' : ''} ${minute}:${seconds}`
}




export const firstChild = (arr) => {
    return [...arr ?? []].shift();
}

export const lastChild = (arr) => {
    return [...arr ?? []].pop();
}


